import axios from 'axios';
import api from './endpoints';

export default {
    list(args) {
        return axios.get(api.EVENT_LIST, {
            params: {
                page: args.page ? args.page : 1,
                size: args.size ? args.size : 20,
                filter: args.filter
            }
        })
            .then((result) => result.data);
    },
    create(args) {
        return axios.post(api.EVENT_LIST, args);
    },
    edit(args) {
        return axios.put(api.resolveEndpoint(api.EVENT_DETAIL, [args.eventId]), args);
    },
    delete(args) {
        return axios.delete(api.resolveEndpoint(api.EVENT_DETAIL, [args.eventId]), args);
    },
    detail(args) {
        return axios.get(api.resolveEndpoint(api.EVENT_DETAIL, [args.eventId]), args);
    },
    availableEvents(args) {
        return axios.get(api.resolveEndpoint(api.AVAILABLE_EVENTS, [args.eventId]), args)
          .then((data) => data.data);
    },
    uploadPaymentLog(args) {
        const form = new FormData();
        form.append('file', args.file);
        return axios.post(api.resolveEndpoint(api.EVENT_PAYMENTS, [args.eventId]), form);
    },
    unsubscribeEvent(args) {
        return axios.put(api.resolveEndpoint(api.UNSUBSCRIBE_TO_EVENT, [args.eventId]), args);
    },
    subscribeEvent(args) {
        return axios.put(api.resolveEndpoint(api.SUBSCRIBE_TO_EVENT, [args.eventId]), args);
    },
    groups(args) {
        return axios.get(api.resolveEndpoint(api.EVENT_GROUPS, [args.eventId]), args).then((data) => data.data);
    },
    generateGroups(args) {
        return axios.put(api.resolveEndpoint(api.EVENT_GROUPS, [args.eventId]), args);
    },
};
